import { jsx as _jsx } from "react/jsx-runtime";
import { PureButton, PureLink } from '../../../basics';
const ProductTileContainer = ({ a11yText, className, dataTestId, onProductClick, url, }) => {
    return url ? (_jsx(PureLink, { "aria-label": a11yText, href: url, onClick: onProductClick, className: className, "data-testid": dataTestId, internal: true })) : (_jsx(PureButton, { onClick: onProductClick, className: className, "data-testid": dataTestId, children: _jsx("span", { className: "screenReaderOnly", children: a11yText }) }));
};
export { ProductTileContainer };
